<template>
  <div>
    <el-button
        style="margin-bottom: 20px;"
        type="primary"
        @click="setsu('null')"
        v-if="hasAuth('sys:kong:add')"
    >添加
    </el-button
    >
    <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%;"
        border
        stripe
    >
      <el-table-column label="图标" align="center">
        <template slot-scope="scope">
          <img width="50px" height="50px" :src="scope.row.cover" alt=""/>
        </template>
      </el-table-column>
      <el-table-column
          label="名称"
          align="center"
          prop="name"
      ></el-table-column>
      <el-table-column
          label="排序"
          align="center"
          prop="sort"
      ></el-table-column>
      <el-table-column label="操作" align="center" prop="icon" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" plain @click="edit(scope.row)" v-if="hasAuth('sys:kong:edit')"
          >编辑
          </el-button
          >
          <el-popconfirm
              v-if="hasAuth('sys:kong:del')"
              title="确定删除吗？"
              @confirm="delHandle(scope.row.id)"
          >
            <el-button type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
        :title="editForm.id ? '编辑' : '新增'"
        :visible.sync="dialogVisible"
        width="800px"
        append-to-body
        :before-close="handleClose"
    >
      <el-form
          :model="editForm"
          ref="editForm"
          label-width="100px"
          class="demo-editForm"
          :rules="rules"
      >
        <el-form-item label-width="100px" label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="图标" prop="cover">
          <VploadImg
              :limit="1"
              :multble="false"
              v-bind:file-list="fileList"
              @submitImg="getImgList"
          >
          </VploadImg>
        </el-form-item>
        <el-form-item label-width="100px" label="跳转地址" prop="url">
          <el-input v-model="editForm.url" placeholder="视频号主页请填写（‘sphzy’+视频号原始ID）" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="排序" prop="sort">
          <el-input v-model="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
          >完成
          </el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgTwo";

export default {
  name: "ConfigType",
  components: {
    VploadImg,
  },
  data() {
    return {
      tableData: [],
      fileList: [],
      editForm: {
        name: "",
        cover: "",
        id: "",
        url: "",
        sort: 0
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        cover: [
          {
            required: true,
            message: "请上传",
            trigger: "change",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
      },
      dialogVisible: false,
    };
  },
  created() {
    this.getTypeList();
  },
  methods: {
    getTypeList() {
      this.$axios.post("/admin/icon/getList").then((res) => {
        this.tableData = res.data;
      });
    },
    delHandle(id) {
      this.$axios
          .post("/admin/icon/deleteIcon", {
            id: id,
          })
          .then((res) => {
            this.getTypeList();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
              },
            });
          });
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
      this.fileList = [];
    },
    getImgList(i) {
      this.editForm.cover = i;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editForm.id) {
            this.$axios
                .post("/admin/icon/updateIcon", {
                  cover: this.editForm.cover,
                  id: this.editForm.id,
                  name: this.editForm.name,
                  url: this.editForm.url,
                  sort: this.editForm.sort
                })
                .then((res) => {
                  this.$refs["editForm"].resetFields();
                  this.dialogVisible = false;
                  this.fileList = [];
                  this.getTypeList();
                  this.$message({
                    showClose: true,
                    message: "恭喜你，操作成功",
                    type: "success",
                    onClose: () => {
                    },
                  });
                });
          } else {
            this.$axios
                .post("/admin/icon/addIcon", this.editForm)
                .then((res) => {
                  this.$refs["editForm"].resetFields();
                  this.dialogVisible = false;
                  this.fileList = [];
                  this.getTypeList();
                  this.$message({
                    showClose: true,
                    message: "恭喜你，操作成功",
                    type: "success",
                    onClose: () => {
                    },
                  });
                });
          }
        }
      });
    },
    setsu() {

      this.dialogVisible = true;
      this.editForm = {
        name: "",
        cover: "",
        id: "",
        url: "",
        sort: 0
      }
    },
    edit(i) {
      this.editForm = JSON.parse(JSON.stringify(i));
      this.fileList = [{url: this.editForm.cover}];
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
